export default "__VITE_ASSET__BuEjUT_U__"